import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 0a1 1 0 0 0-.934.642 46 46 0 0 0-.319.861c-.19.524-.443 1.243-.697 2.02a38 38 0 0 0-.707 2.388C6.155 6.655 6 7.42 6 8c0 2.863 2.154 5.422 5.004 5.915L11 14v8H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-8q0-.043-.004-.085C15.846 13.422 18 10.863 18 8c0-.58-.155-1.345-.343-2.09a38 38 0 0 0-.707-2.387 70 70 0 0 0-.992-2.818L15.94.659l-.006-.015V.642A1 1 0 0 0 15 0zm.695 2-.067.185a67 67 0 0 0-.678 1.96 36 36 0 0 0-.668 2.257q-.083.324-.14.598h7.716a16 16 0 0 0-.14-.598 36 36 0 0 0-.668-2.257 67 67 0 0 0-.678-1.96L14.305 2zm6.17 7h-7.73c.459 1.674 2.025 3 3.865 3s3.406-1.326 3.864-3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }